export enum AnalyticsView {
  Services,
  Donations
}
